import { Controller } from "stimulus";
import {
  applyErrorMsg,
  handleSubmitForm,
  validateForm,
} from 'shared/assets/javascript/forms.js';
import { FocusTrap } from 'shared/assets/javascript/accessibility/focusTrap.js';
export default class extends Controller {
  static targets = ['form', 'overlay', 'overlayForm', 'email', 'overlayEmail', 'closeButton', 'successModal'];

  connect() {
    this.emailTarget.addEventListener('input', () => {
      this.overlayEmailTarget.value = this.emailTarget.value;
    });

    this.modal = this.overlayTarget
    this.modalToggle = this.closeButtonTarget
    this.successModal = this.successModalTarget
    this.focusTrapInstance = new FocusTrap([this.modalToggle, this.modal])
    this.sucessFocusTrapInstance = new FocusTrap([this.modalToggle, this.successModal])
  }

  close() {
    document.body.classList.remove('-hide-page-overflow');
    this.overlayTarget.classList.remove('newsletter-overlay--open');
    if (this.focusTrapInstance) this.focusTrapInstance.unset();
    if (this.sucessFocusTrapInstance) this.sucessFocusTrapInstance.unset();

  }

  open() {
    document.body.classList.add('-hide-page-overflow');
    this.overlayTarget.classList.add('newsletter-overlay--open');
    this.focusTrapInstance.set()
  }

  activate(e) {
    e.preventDefault();
    let valid = validateForm(this.formTarget);
    if (valid) this.open();
  }

  async submit(e) {
    e.preventDefault();
    let response = await handleSubmitForm(this.formTarget);
    if (response?.success) {
      this.element.classList.add('-is-success');
      setTimeout(() => {
        this.element.classList.remove('-is-success');
        this.formTarget.reset();
      }, 5000);
    } else {
      console.error('Form not submitted', response);
      applyErrorMsg(this.emailTarget, response.message);
    }
  }

  async submitRevinate(e) {
    e.preventDefault();
    let response = await handleSubmitForm(this.overlayFormTarget);
    if (response?.success) {
      this.overlayTarget.classList.add('-is-success');
      this.focusTrapInstance.unset();
      this.sucessFocusTrapInstance.set();
      setTimeout(() => {
        this.overlayTarget.classList.remove('-is-success');
        this.overlayFormTarget.reset();
        this.formTarget.reset();
        this.close();
      }, 20000);
    } else {
      console.error('Form not submitted');
    }
  }
}
